import { mapGetters, mapActions } from "vuex";

let CommonMixin = {
  data: () => ({
    //
  }),
  components: {
    //
  },
  computed: {
    ...mapGetters({
      GE_IS_TODAY: "loginStore/GE_IS_TODAY",
      GE_PUT_FETCH_VIEW_DATA: "inquiryStore/GE_PUT_FETCH_VIEW_DATA",
      GE_PUT_FETCH_LIST_INFO_DATA: "fetchAction/GE_PUT_FETCH_LIST_INFO_DATA",
    }),
  },
  methods: {
    ...mapActions({
      AC_PUT_FETCH_DATA: "fetchAction/AC_PUT_FETCH_DATA",
    }),
    $MOVE_FUNC: function (text, params) {
      return this.$router.push({ name: text, params: params }).catch(() => {});
    },
  },
  mounted() {
    //
  },
  watch: {
    //
  },
};

export default CommonMixin;
